import Button from '@blocks/Button'
import EditableList from '@modules/List'
import Flex from '@blocks/Flex'
import Form from '@blocks/Form'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Image from '@blocks/Input/Image'
import Select from '@blocks/Select'
import React from 'react'
import styled from 'styled-components'
import { useSalonEditContext } from '../../context'
import AwardInput from './components/AwardInput'
import PatronageInputs from './components/PatronageInputs'
import SectionInput from './components/SectionInput'

export default function SalonForm({ url, method, handleSuccess, salon }: Props) {
    const { countries, organizations, sections, awards } = useSalonEditContext()

    return (
        <Form action={url} handleSuccess={handleSuccess} method={method}>
            <Grid gap="30px|30px|60px">
                <Grid>
                    <ImageContainer>
                        <Image id="background" name="background" src={salon?.background_url} required={!salon} />
                    </ImageContainer>
                    <Grid columns="3" gap="30px|60px">
                        <Grid gap="20px">
                            <div><h2 className="h3">Info</h2></div>
                            <Input id="name" name="name" defaultValue={salon?.name} label="Name" placeholder="Ukraine Photo Salon" required />
                            <Select id="country_id" name="country_id" value={countries.find(item => item.value === salon?.country_id.toString())} label="Country" options={countries} required />
                        </Grid>
                        <Grid gap="20px">
                            <div><h2 className="h3">Patronages</h2></div>
                            <EditableList items={salon?.patronages} element={PatronageInputs} options={{ organizations }} />
                        </Grid>
                        <Grid gap="20px">
                            <div><h2 className="h3">Calendar</h2></div>
                            <Input id="start_date" name="start_date" defaultValue={salon?.start_date} label="Start of entries date" type="date" required />
                            <Input id="closing_date" name="closing_date" defaultValue={salon?.closing_date} label="Closing date" type="date" required />
                            <Input id="results_date" name="results_date" defaultValue={salon?.results_date} label="Results date" type="date" required />
                            <Input id="awards_date" name="awards_date" defaultValue={salon?.awards_date} label="Awards & catalogue date" type="date" required />
                        </Grid>
                        <Grid gap="20px">
                            <div><h2 className="h3">Sections</h2></div>
                            <EditableList items={salon?.sections} element={SectionInput} options={{ sections }} />
                        </Grid>
                        <Grid gap="20px">
                            <div><h2 className="h3">Awards</h2></div>
                            <EditableList items={salon?.awards} element={AwardInput} options={{ awards }} />
                        </Grid>
                        <Grid gap="20px">
                            <div><h2 className="h3">Options</h2></div>
                            <Input id="fee" name="fee" defaultValue={salon?.fee} label="Fee (€)" required />
                            <Input id="slug" name="slug" defaultValue={salon?.slug} label="URL" required />
                            <Grid gap="10px">
                                <p><b>Nudity</b></p>
                                <Input id="nudity_restricted" name="nudity_restricted" type="checkbox" checked={salon?.nudity_restricted || undefined} label="Restricted" />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Flex justifyContent="flex-end"><Button element="submit" width="fixed">Continue</Button></Flex>
            </Grid>
        </Form>
    )
}

interface Props {
    url: string
    method: "post" | "patch"
    handleSuccess(data: any, form?: HTMLFormElement): void
    salon?: Admin.Resources.Salon
}

// STYLES
const ImageContainer = styled.div`
    width: 100%;
    height: 300px;
`